import { handleResponse, handleError } from "./apiUtils";


const baseUrlLogs = "/api/logs/";

// Get list of log files
export async function getLogFiles() {
  try {
    const response = await fetch(baseUrlLogs + "files", {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}

// Get content of a specific log file
export async function getLogContent(fileName) {
  try {
    const response = await fetch(baseUrlLogs + "file/" + fileName, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "application/json",
      }),
    });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
}